import { globalVariables } from "helper/globalVariables";
import { TabBar } from "shared/Components/tabBar";
import { SimpleCard } from "./Components/SimpleCard";
import { globalClasses } from "helper/globalClasses";
import { sortAlphabeticallyByCategory } from "helper/sortAlphabeticallyByCategory";
import { TableWithPagination } from "shared/Components/tableWithPagination/index.js";
import {
  addBlack,
  backIcon,
  downloadWhite,
  editBlack,
  edit,
  pencil,
  pencilAlt,
  download,
} from "helper/icons";
import {
  RoleContext,
} from "context/RoleContext";
import { ROLE } from "helper/utility";
import { InfoCard } from "./Components/InfoCard";
import CustomDatePicker from "shared/Components/datepicker";
import Dropdown from "shared/Components/dropdown";
import { useMediaQuery } from "react-responsive";
import { Button } from "shared/Components/button";
import PageInfo from "shared/Components/pageInfo";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ModalCard } from "shared/Components/modalCard";
import { EditDogCard } from "./Components/EditDogCard";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { useLocation, useNavigate } from "react-router-dom";
import { AddNoteModal } from "container/SuperAdmin/ManageDogs/AdminDogHistory/AddNoteModal";
import { EditNAEResult } from "container/SuperAdmin/ManageDogs/AdminDogHistory/EditNAEResult";
import { UPDATE_DOG_STATUS } from "redux/features/editSite/EditSiteApi";
import { useLazyQuery, useQuery, useMutation } from "@apollo/client";
import {
  getAllPremierAndNonPremierResultQuery,
  getAllSummaryQuery,
  getAllTitlesDashboardQuery,
  getAllTitlesEarnedQuery,
  getAllTrialIndividualDogHistory,
  getDogsQuery,
  getRegisteredDogSITByIdQuery,
  updateTrialzEarnedDate,
  passDogNoviceLevel,
  DogRegistrationStatusUpdate,
} from "redux/features/dogSlice/dogGql";
import {
  updateRegisteredDogMarkPaidMutation,
} from "redux/features/superAdminSlice/managePaymentSlice/managePaymentGql";
import Loader from "shared/Components/loader";
import { client } from "helper/apolloConfig";
import { pendingPayment, successPayment } from "helper/icons";
import moment from "moment";
import AdminDogInfo from "./Components/AdminDogInfo";
import { Certificate, CertificateContext } from "container/Certificate";
import SearchBar from "shared/Components/search";
import { debounce } from "lodash";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import EditeQs from "./Components/EditQs";
import { SkipNoviceModal } from "./Components/SkipNoviceModal";
import ScrollToTop from "shared/Components/scrollToTop";

const headData = [
  globalVariables.title,
  globalVariables.shortTitle,
  globalVariables.date,
  globalVariables.downloadCertificate,
];

const pointSummaryHeadData = [
  globalVariables.trialLocation,
  globalVariables.date,
  globalVariables.pointsEarned,
  globalVariables.totalPoints,
];

const pointSummaryTableData = [
  {
    location: "White House, TN",
    date: "06/02/2023",
    points: "80.04",
    totalPoints: "235.19",
  },
  {
    location: "White House, TN",
    date: "06/02/2023",
    points: "80.04",
    totalPoints: "235.19",
  },
  {
    location: "White House, TN",
    date: "06/02/2023",
    points: "80.04",
    totalPoints: "235.19",
  },
];

const premierHeadData = [
  globalVariables.date,
  globalVariables.trialLocation,
  globalVariables.search,
  globalVariables.handler,
  globalVariables.dog,
  globalVariables.breed,
  globalVariables.div,
  globalVariables.qNq,
  globalVariables.faultsOf,
  globalVariables.faults,
  globalVariables.time,
  globalVariables.hidesFound,
  globalVariables.points,
  globalVariables.place,
  globalVariables.timeLimit,
  globalVariables.hideSet,
  globalVariables.judgeNotes,
  globalVariables.searchName,
  globalVariables.hide1,
  globalVariables.hide2,
  globalVariables.hide3,
  globalVariables.hide4,
  globalVariables.hide5,
  globalVariables.hide6,
  globalVariables.hide7,
  globalVariables.edit,
];

const noviceHeadData = [
  globalVariables.date,
  globalVariables.trialLocation,
  globalVariables.element,
  globalVariables.handler,
  globalVariables.dog,
  globalVariables.breed,
  globalVariables.div,
  globalVariables.qNQ,
  globalVariables.nqReason,
  globalVariables.time,
  globalVariables.hidesFound,
  globalVariables.faultsOf,
  globalVariables.faultReason,
  globalVariables.points,
  globalVariables.place,
  globalVariables.timeLimit,
  globalVariables.hideSet,
  globalVariables.judgeNotes,
  globalVariables.edit,
];

const locationDropdown = ["Texas", "Florida"];

export const DogHistory = (props) => {
  const { isAdmin, host, dogId, newDogId } = props || {};
  const role = useContext(RoleContext);
  const isAdminRole = role === ROLE.SuperAdmin;
  const { paginatedDataCls } = globalClasses;
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const isTablet = useMediaQuery({
    query: "(max-width: 1024px) and (min-width: 480px)",
  });
  const { data, loading, refetch: refetchDogs } = useQuery(getDogsQuery, {
    fetchPolicy: "no-cache",
  });
  const [updateDogStatus] = useMutation(UPDATE_DOG_STATUS);

  const titlesEarnedModalRef = useRef();
  const premiumPointsModalRef = useRef();
  const premierModalRef = useRef();
  const noviceModalRef = useRef();
  const EditNAEModalRef = useRef();
  const addNoteModalRef = useRef();
  const editDogModalRef = useRef();
  const certificateRef = useRef();
  const skipNoviceRef = useRef();
  const [date, setDate] = useState("");
  const [dogIdData, setDogIdData] = useState(0);
  const [newDogIdData, setNewDogIdData] = useState(0);
  const [nonPremierResultsIndex, setNonPremierResultsIndex] = useState(0);
  const [premierResultsIndex, setPremierResultsIndex] = useState(0);
  const [allTitlesEarnedIndex, setAllTitlesEarnedIndex] = useState(0);
  const [titlesIndex, setTitlesIndex] = useState(0);
  const [premierResultsPage, setPremierResultsPage] = useState(1);
  const [nonPremierResultsPage, setNonPremierResultsPage] = useState(1);
  const [premiumPointsPage, setPremiumPointsPage] = useState(1);
  const [allTitlesEarnedPage, setAllTitlesEarnedPage] = useState(1);
  const [dogSIT, setDogSIT] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [summaryStandard, setSummaryStandard] = useState([]);
  const [isDataUpdated, setIsDataUpdated] = useState(false);
  const [selectNAEData, setSelectNAEData] = useState({});
  const [certLoading, setCertLoading] = useState(false);
  const [tabChanged, setTabChanged] = useState(false);
  const [isEditingPremierResults, setIsEditingPremierResults] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState("");

  const inputRef = useRef(null);

  const [editingContext, setEditingContext] = useState(null);

  const [tempDate, setTempDate] = useState("");

  const {
    dogId: dogIdInfo,
    newDogId: newDogIdInfo,
    isMember,
    dogIndex,
  } = location.state || {};

  const [
    getData,
    { loading: premierResultsLoading, data: premierResults, error },
  ] = useLazyQuery(getAllPremierAndNonPremierResultQuery, {
    fetchPolicy: "no-cache",
  });
  const [
    getnonPremierResultsData,
    {
      loading: nonPremierResultsLoading,
      data: nonPremierResults,
      error: nonPremierError,
    },
  ] = useLazyQuery(getAllPremierAndNonPremierResultQuery, {
    fetchPolicy: "no-cache",
  });
  const [
    getAllSummaryPro,
    {
      loading: getAllSummaryProLoading,
      data: getAllSummaryProData,
      error: getAllSummaryProError,
      refetch: getAllSummaryProRefetch,
    },
  ] = useLazyQuery(getAllSummaryQuery, {
    fetchPolicy: "no-cache",
  });

  const [
    getRegisteredDogSIT,
    {
      data: getRegisteredDogSITData,
      refetch: getRegisteredDogSITRefetch,
    },
  ] = useLazyQuery(getRegisteredDogSITByIdQuery, {
    fetchPolicy: "no-cache",
  });

  const [
    getAllSummaryStandard,
    {
      loading: getAllSummaryStandardLoading,
      data: getAllSummaryStandardData,
      error: getAllSummaryStandardError,
      refetch: getAllSummaryStandardRefetch,
    },
  ] = useLazyQuery(getAllSummaryQuery, {
    fetchPolicy: "no-cache",
  });

  const [
    getAllTitlesEarned,
    {
      loading: allTitlesEarnedLoading,
      data: allTitlesEarned,
      error: allTitlesEarnedError,
      refetch: allTitlesRefetch,
    },
  ] = useLazyQuery(getAllTitlesEarnedQuery, {
    fetchPolicy: "no-cache",
  });

  const hasPremierData =
    premierResults?.getAllPremierAndNonPremierResult?.data?.length > 0;

  const [
    fetchAllTrialIndividualDogHistory,
    {
      loading: allTrialIndividualLoading,
      data: allTrialIndividualDogHistory,
      error: allTrialIndividualError,
    },
  ] = useLazyQuery(getAllTrialIndividualDogHistory, {
    fetchPolicy: "no-cache",
  });

  const[isNoviceSkiped, setIsNoviceSkiped] = useState(false);

  const skipNoviceHandler = async () => {
    try {
      const { data } = await client.mutate({
        mutation: passDogNoviceLevel,
        variables: {
          dogId: dogIdData,
        },
      });
      skipNoviceRef.current?.closeModal()
      setIsNoviceSkiped(true);
      if (data?.passDogNoviceLevel?.message) {
        getRegisteredDogSITRefetch();
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.success,
          desc: data?.passDogNoviceLevel?.message,
          type: "success",
        });
      }
    } catch (error) {
      skipNoviceRef.current?.closeModal();
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: error?.message,
        type: "pending",
      });
    }
  }

  const hasPremiumData =
    allTrialIndividualDogHistory?.getAllTrialIndividualDogHistory?.data
      ?.length > 0 ||
    search.length ||
    date ||
    allTrialIndividualLoading;

  async function updateSITValue(data) {
    const key = data.key?.toLowerCase();
    // console.log("Key " , key , data.value);
    // return;
    const { data: mutationData } = await updateDogStatus({
      variables: {
        id: newDogIdInfo ? newDogIdInfo : dogId,
        data: { [key]: data.value },
      },
    });
  }

  useEffect(() => {
    if (dogIdData > 0) {
      getAllTitlesEarned({
        variables: {
          pageNumber: allTitlesEarnedPage,
          pageSize: 1000,
          dogId: dogIdData,
        },
      });
    }
  }, [allTitlesEarnedPage]);

  useEffect(() => {
    if (dogIdData > 0) {
      fetchAllTrialIndividualDogHistory({
        variables: {
          pageNumber: premiumPointsPage,
          pageSize: 10,
          dogId: dogIdData,
          date: date ? moment(date).format("YYYY-MM-DD") : "",
          location: search,
        },
      });
    }
  }, [search, date, premiumPointsPage]);

  useEffect(() => {
    setDogIdData(host || isMember ? dogIdInfo : dogId);
    setNewDogIdData(host || isMember ? dogIdInfo : newDogId);
    getDogHistory(
      host || isMember ? dogIdInfo : dogId,
      host || isMember ? newDogIdInfo : newDogId
    );
  }, [dogId, dogIdInfo, newDogId, newDogIdInfo]);

  useEffect(() => {
    if (data?.getMyRegisteredDogs?.length && !isMember && !isAdmin && !host) {
      const selectedIndex = dogIndex ?? 0;
      const selectedDog = data?.getMyRegisteredDogs[selectedIndex] ?? data?.getMyRegisteredDogs[0];
      getDogHistory(
        selectedDog?.id,
        selectedDog?.dog_id
      );
    }
  }, [data?.getMyRegisteredDogs?.length]);

  const isCountUpdatedHandler = () => {
    allTitlesRefetch();
    getAllSummaryStandardRefetch();
    getAllSummaryProRefetch();
    getDashboardData(dogId);
  }

  useEffect(() => {
    if (dogIdData > 0) {
      getData({
        variables: {
          pageNumber: premierResultsPage,
          pageSize: 10,
          dogId: dogIdData,
          search: "Premier",
        },
      });
    }
  }, [premierResultsPage]);

  useEffect(() => {
    if (dogIdData > 0) {
      getnonPremierResultsData({
        variables: {
          pageNumber: nonPremierResultsPage,
          pageSize: 10,
          dogId: dogIdData,
          search: "Nonpremier",
        },
      });
    }
  }, [nonPremierResultsPage]);

  const getDogHistory = (dogId, newDogId) => {
    if(!dogId) return null;
    setDogIdData(dogId);
    getRegisteredDogSIT({
      variables: {
        dogId,
      },
    });
    getAllSummaryPro({
      variables: {
        dogId,
        summaryType: "P",
      },
    });
    getAllSummaryStandard({
      variables: {
        dogId,
        summaryType: "S",
      },
    });
    getData({
      variables: {
        pageNumber: premierResultsPage,
        pageSize: 10,
        dogId: dogId,
        search: "Premier",
      },
    });
    getnonPremierResultsData({
      variables: {
        pageNumber: nonPremierResultsPage,
        pageSize: 10,
        dogId: dogId,
        search: "Nonpremier",
      },
    });
    getDashboardData(dogId);
    getAllTitlesEarned({
      variables: {
        pageNumber: allTitlesEarnedPage,
        pageSize: 1000,
        dogId,
      },
    });
    fetchAllTrialIndividualDogHistory({
      variables: {
        pageNumber: premiumPointsPage,
        pageSize: 10,
        dogId,
        date: "",
        location: "",
      },
    });
  };

  const modalRef = useRef();
  
  const dogDetails = dashboardData ? dashboardData.dog : {} ;

  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });

  const onChangeStatus = async (paymentStatus) => {
    if (!dogDetails.authId) return null;
    const { id } = dashboardData.dog;

    try {
      const [statusRes, paymentRes] = await Promise.all([
        client.mutate({
          mutation: DogRegistrationStatusUpdate,
          variables: { id, status: "Active" },
        }),
        client.mutate({
          mutation: updateRegisteredDogMarkPaidMutation,
          variables: { 
            dogId: String(id), 
            data: { payment_status: paymentStatus } 
          },
        }),
      ]);

      if (paymentRes?.data?.updateRegisteredDogMarkPaid) {
        getDashboardData(dogId);
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.success,
          desc: paymentRes.data.updateRegisteredDogMarkPaid.message,
          type: "success",
        });
      }
    } catch (error) {
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: error?.message,
        type: "pending",
      });
    }
  };

  const getDashboardData = async (dogId) => {
    try {
      const res = await client.query({
        query: getAllTitlesDashboardQuery,
        variables: {
          dogId,
        },
        fetchPolicy: "network-only",
      });

      const dashboardValues = res?.data?.getAllTitlesDashboard;
      setIsNoviceSkiped(dashboardValues.dog.noviceLevel);
      setDashboardData(dashboardValues);
    } catch {}
  };

  useEffect(()=> {
    if(isDataUpdated) {
      getDashboardData(dogId);
      refetchDogs(); // Refetch the dogs list to update the dog names in tabs
      editDogModalRef.current?.closeModal()
      setIsDataUpdated(false);
    }
  })

  useEffect(() => {
    const dogSITData = getRegisteredDogSITData?.getRegisteredDogSITById;
    setDogSIT([
      { key: "SIT", value: "Results" },
      { key: "Birch", value: dogSITData?.birch },
      { key: "Anise", value: dogSITData?.anise },
      { key: "Clove", value: dogSITData?.clove },
    ]);
  }, [getRegisteredDogSITData])
  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      if (editingContext) {
        const { sectionIndex, itemIndex } = editingContext;
        const data = getShortTitleEarned[sectionIndex]?.titleEarned[itemIndex];
        handleDateChange(tempDate, data);
      }
      setEditingContext(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [editingContext, tempDate]);

  const getDateAndSearch = (data) => {
    return {
      search: data.search,
      date: moment.utc(data.date).format("MM/DD/YYYY"),
      shortName: data.shortName,
    };
  };

  const handleDateChange = async (newDate, data) => {
    const previousDate = moment(data?.date).format("MM/DD/YYYY");

    const date1 = moment(previousDate, "MM/DD/YYYY");

    const date2 = moment(newDate, "MM/DD/YYYY");

    const searchTerm =  data.search;

    const shortName =  data.shortName;

    if (date1.isSame(date2, 'day')) return null;

    const formattedDate = moment.utc(newDate).isValid()
    ? moment.utc(newDate).format("YYYY-MM-DD")
    : null;

    if (!newDate || !searchTerm || !formattedDate) {
      return;
    }
    
    if (moment(newDate).isAfter(moment(), 'day')) {
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: "Ooops!",
        desc: "You've entered a date in the future. Please check the date and try again.",
        type: "pending",
      });
      return;
    }
  
    try {
      const { data } = await client.mutate({
        mutation: updateTrialzEarnedDate,
        variables: {
          dogId: dogIdData,
          search: searchTerm,
          date: formattedDate,
          shortName,
          summaryType: null,  // Optional - editing existing title date
        },
      });
  
      if (data?.updateTrialzEarnedDate?.message) {
        allTitlesRefetch();
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.success,
          desc: data?.updateTrialzEarnedDate?.message,
          type: "success",
        });
      }
    } catch (error) {
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: "Ooops!",
        desc: error?.message || "Something went wrong updating the title date. Please try again.",
        type: "pending",
      });
    }
  };

  const renderPointSummaryTableBody = () => {
    return allTrialIndividualDogHistory?.getAllTrialIndividualDogHistory?.data?.map(
      (data, index) => (
        <tr key={index}>
          <td className={paginatedDataCls(index)}>
            {data.trialLocation ? data.trialLocation : "-"}
          </td>
          <td className={paginatedDataCls(index, "min-w-[152px]")}>
            {moment.utc(data.date).format("MM/DD/YYYY")}
          </td>
          <td className={paginatedDataCls(index)}>{data.earnedPoints}</td>
          <td className={paginatedDataCls(index)}>{data.totalPoints}</td>
        </tr>
      )
    );
  };

  const renderMobilePointSummaryTableBody = () => {
    return allTrialIndividualDogHistory?.getAllTrialIndividualDogHistory?.data?.map(
      (data) => (
        <div key={data.trialLocation}>
          <div className="flex flex-col p-4 border-b border-gray-200">
            <div className="flex flex-row justify-between">
              <span className="text-base font-semibold text-gray-900">
                {data.trialLocation}
              </span>
              <span className="text-sm font-normal text-gray-600">
                {moment.utc(data.date).format("MM/DD/YYYY")}
              </span>
            </div>
            <div className="flex flex-row justify-between items-center mt-3">
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-gray-600">
                  {globalVariables.totalPoints}
                </span>
                <span className="text-sm font-normal text-gray-600 mt-1">
                  {data.totalPoints}
                </span>
              </div>
              <Button
                onClick={() => premiumPointsModalRef.current.openModal()}
                label={globalVariables.viewMore}
                width="w-[104px]"
              />
            </div>
          </div>
        </div>
      )
    );
  };

  const formatHideLocationStatus = (location, found) => {
    if (!location) return "-";
    const icon = found ? "✔️" : "❌";
    return `${location} ${icon}`;
  };

  const renderPremierTableBody = () => {
    return premierResults?.getAllPremierAndNonPremierResult?.data?.map(
      (data, index) => (
        <tr key={data.location}>
          <td className={paginatedDataCls(index)}>
            {moment.utc(data.date).format("MM/DD/YYYY")}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.trialLocation ? data.trialLocation : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.search ? data.search : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.handler ? data.handler : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.dog ? data.dog : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.breed_mix || data.breed}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.div ? data.div : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.qNq ? data.qNq : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.faults ? data.faults : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.faultReason ? data.faultReason : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.time ? data.time : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.hidesFound ? data.hidesFound : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.points ? data.points : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.place ? data.place : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.timeLimit ? data.timeLimit : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.hidesSet ? data.hidesSet : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.judgeNotes ? data.judgeNotes : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.searchName ? data.searchName : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {formatHideLocationStatus(data?.hide1Location, data?.hide1Found)}
          </td>
          <td className={paginatedDataCls(index)}>
          {formatHideLocationStatus(data?.hide2Location, data?.hide2Found)}
          </td>
          <td className={paginatedDataCls(index)}>
          {formatHideLocationStatus(data?.hide3Location, data?.hide3Found)}
          </td>
          <td className={paginatedDataCls(index)}>
          {formatHideLocationStatus(data?.hide4Location, data?.hide4Found)}
          </td>
          <td className={paginatedDataCls(index)}>
          {formatHideLocationStatus(data?.hide5Location, data?.hide5Found)}
          </td>
          <td className={paginatedDataCls(index)}>
          {formatHideLocationStatus(data?.hide6Location, data?.hide6Found)}
          </td>
          <td className={paginatedDataCls(index)}>
          {formatHideLocationStatus(data?.hide7Location, data?.hide7Found)}
          </td>
          {isAdmin && (
            <td className={paginatedDataCls(index)}>
              <div
                onClick={() => {
                  setIsEditingPremierResults(true);
                  setSelectNAEData(data);
                  EditNAEModalRef.current.openModal();
                }}
                className={`flex cursor-pointer justify-center items-center flex-1 py-2`}
              >
                <img src={pencilAlt} alt="" />
              </div>
            </td>
          )}
        </tr>
      )
    );
  };

  const renderNoviceTableBody = () => {
    return nonPremierResults?.getAllPremierAndNonPremierResult?.data?.map(
      (data, index) => (
        <tr key={data.location}>
          <td className={paginatedDataCls(index)}>
            {moment.utc(data.date).format("MM/DD/YYYY")}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.trialLocation ? data.trialLocation : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.search ? data.search : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.handler ? data.handler : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.dog ? data.dog : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.breed_mix || data.breed}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.div ? data.div : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.qNq ? data.qNq : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.ngReason ? data.ngReason : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.time ? data.time : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.hidesFound ? data.hidesFound : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.faults ? data.faults : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.faultReason ? data.faultReason : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.points ? data.points : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.place ? data.place : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.timeLimit ? data.timeLimit : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.hidesSet ? data.hidesSet : "-"}
          </td>
          <td className={paginatedDataCls(index)}>
            {data.judgeNotes ? data.judgeNotes : "-"}
          </td>
          {isAdmin && (
            <td className={paginatedDataCls(index)}>
              <div
                onClick={() => {
                  setSelectNAEData(data);
                  setIsEditingPremierResults(false);
                  EditNAEModalRef.current.openModal();
                }}
                className={`flex cursor-pointer justify-center items-center flex-1 py-2`}
              >
                <img src={pencilAlt} alt="" />
              </div>
            </td>
          )}
        </tr>
      )
    );
  };

  const renderMobilePremierTableBody = () => {
    return premierResults?.getAllPremierAndNonPremierResult?.data?.map(
      (data, index) => (
        <div key={data.trialLocation} className="mb-5 pt-5 relative">
          {isAdmin && (
            <div
              onClick={() => {
                setSelectNAEData(data);
                EditNAEModalRef.current.openModal();
              }}
              className={`absolute top-2 right-3`}
            >
              <img src={pencilAlt} alt="" />
            </div>
          )}
          <div className="flex flex-col p-4 border-b border-gray-200">
            <div className="flex flex-row justify-between">
              <span className="text-base font-semibold text-gray-900">
                {data.trialLocation}
              </span>
              <span className="text-sm font-normal text-gray-600">
                {moment.utc(data.date).format("MM/DD/YYYY")}
              </span>
            </div>
            <div className="flex flex-row justify-between items-center mt-3">
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-gray-600">
                  {globalVariables.search}
                </span>
                <span className="text-sm font-normal text-gray-600 mt-1">
                  {data.search}
                </span>
              </div>
              <Button
                onClick={() => {
                  setPremierResultsIndex(index);
                  premierModalRef.current.openModal();
                }}
                label={globalVariables.viewMore}
                width="w-[104px]"
              />
            </div>
          </div>
        </div>
      )
    );
  };

  const renderMobileNoviceTableBody = () => {
    return nonPremierResults?.getAllPremierAndNonPremierResult?.data?.map(
      (data, index) => (
        <div key={data.trialLocation} className="mb-5 pt-5 relative">
          {isAdmin && (
            <div
              onClick={() => {
                setSelectNAEData(data);
                EditNAEModalRef.current.openModal();
              }}
              className={`absolute top-2 right-3`}
            >
              <img src={pencilAlt} alt="" />
            </div>
          )}
          <div className="flex flex-col p-4 border-b border-gray-200">
            <div className="flex flex-row justify-between">
              <span className="text-base font-semibold text-gray-900">
                {data.trialLocation}
              </span>
              <span className="text-sm font-normal text-gray-600">
                {moment.utc(data.date).format("MM/DD/YYYY")}
              </span>
            </div>
            <div className="flex flex-row justify-between items-center mt-3">
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-gray-600">
                  {data.search ? data.search : "-"}
                </span>
              </div>
              <Button
                onClick={() => {
                  noviceModalRef.current.openModal();
                  setNonPremierResultsIndex(index);
                }}
                label={globalVariables.viewMore}
                width="w-[104px]"
              />
            </div>
          </div>
        </div>
      )
    );
  };

  const getShortTitleEarned = allTitlesEarned?.getAllTitlesEarned?.data || [];

  const [loadingSectionIndex, setLoadingSectionIndex] = useState(null);

  const CertificateTable = () => {
    return (
      <div className="bg-white border-purple-100 rounded-md shadow-100">
        <div className="bg-lightBlue/60 rounded-tl-md rounded-tr-md flex justify-between py-4">
          <div className="px-4 text-md font-bold text-gray-900">TITLES EARNED</div>
          <div className="px-4 text-md font-bold text-gray-900">Certificate</div>
        </div>
        <div className="p-4">
          {getShortTitleEarned && getShortTitleEarned.length > 0 ? (
            <table className="w-full border-collapse">
              <tbody>
                {getShortTitleEarned.map((section, sectionIndex) => {
                  const isPro = section.type.toLowerCase().includes('pro');

                  return (
                  <React.Fragment key={sectionIndex}>
                    <tr>
                      <td className="p-2 font-bold text-gray-800">{section.type}</td>
                      <td className="p-2 font-bold text-gray-800 hidden md:table-cell">
                        {/* Only show shortName if NOT a Pro section OR if it's earned (has shortName) */}
                        {!isPro && section.shortName}
                      </td>
                      <td className="p-2 font-bold text-gray-800">
                        {/* Only show date if NOT a Pro section AND has shortName */}
                        {!isPro && section.shortName && moment.utc(section.date).format("MM/DD/YYYY")}
                      </td>
                      <td
                        className="p-2"
                        onClick={() => {
                          if (!certLoading && section.shortName && !isPro) {
                            setLoadingSectionIndex(sectionIndex);
                            certificateRef.current?.onGenerateCertificate(
                              dashboardData?.dog?.call_name,
                              section.type,
                              section.date
                            );
                          }
                        }}
                      >
                        {/* Only show download for non-Pro sections with shortName */}
                        {!isPro && section.shortName && (
                          certLoading && loadingSectionIndex === sectionIndex
                            ? <Loader />
                            : <img className="cursor-pointer" src={download} alt="Download" />
                        )}
                      </td>
                    </tr>
                    {section.titleEarned.map((item, itemIndex) => {
                      const { search, date, shortName } = getDateAndSearch(item);
                      const isEditing = editingContext?.sectionIndex === sectionIndex && editingContext?.itemIndex === itemIndex;
                      const isDownloadedIndex = titlesIndex?.sectionIndex === sectionIndex && titlesIndex?.itemIndex === itemIndex;
  
                      return (
                        <tr key={itemIndex}>
                          <td className="p-2">{search}</td>
                          <td className="p-2 hidden md:table-cell">{shortName}</td>
                          <td
                            className="p-2 cursor-pointer"
                            onClick={() => {
                              if (isAdmin) {
                                setEditingContext({ sectionIndex, itemIndex });
                                setTempDate(date);
                              }
                            }}
                          >
                            {isAdmin && isEditing ? (
                              <div className="relative w-[150px]">
                                <input
                                  type="text"
                                  value={tempDate}
                                  ref={inputRef}
                                  onChange={(e) => setTempDate(e.target.value)}
                                  autoFocus
                                  className="border rounded px-2 py-1 w-full pr-8"  // padding-right for icon space
                                />
                                <span
                                  className="absolute right-2 top-1/2 -translate-y-1/2 text-green-600 cursor-pointer"
                                  aria-hidden="true"
                                >
                                  ✔️
                                </span>
                              </div>
                            ) : isAdmin ? (
                              <div className="flex gap-2">
                                {date}
                                <img src={pencilAlt} alt="Edit" />
                              </div>
                            ) : (
                              date
                            )}
                          </td>
                          <td
                            className={`p-2 ${!certLoading ? "cursor-pointer" : ""}`}
                            onClick={() => {
                              if (!certLoading) {
                                setTitlesIndex({ sectionIndex, itemIndex });
                                certificateRef.current?.onGenerateCertificate(
                                  dashboardData?.dog?.call_name,
                                  search,
                                  date
                                );
                              }
                            }}
                          >
                            {certLoading && isDownloadedIndex ? <Loader /> : <img src={download} alt="Download" />}
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="text-center text-gray-600 py-6">No Titles Earned found</div>
          )}
        </div>
      </div>
    );
  };
  

  const onSearch = (event) => {
    const value = event?.target?.value;
    setSearch(value);
  };
  const debouncedSearch = debounce(onSearch, 1000);

  const headerComponent = () => {
    return (
      <div className={`flex flex-row items-center  z-60 ${isMobile && "mt-3"}`}>
        <CustomDatePicker
          width={isMobile ? "w-[158px]" : "w-[152px]"}
          placeholder={globalVariables.date}
          dateFormat="MM/DD"
          showIconLeft
          onSetDate={setDate}
          defaultDate={date}
          onClear={() => setDate("")}
        />
        <div className="mr-3" />
        {/* <Dropdown
          dropdownOptions={locationDropdown}
          placeholder={globalVariables.location}
          width={isMobile ? "w-[158px]" : "w-[119px]"}
          showIconLeft
        /> */}
        <SearchBar
          width={isMobile ? "w-[158px]" : "w-[132px]"}
          onChange={debouncedSearch}
          placeholder={"Search"}
          isFaded={true}
        />
      </div>
    );
  };

  const showDefaultValue = (value) => {
    return value ? value : "-";
  };

  return data?.getMyRegisteredDogs?.length > 0 || isAdmin || host ? (
    <div
      className="App rounded-md  min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10"
    >
      <ScrollToTop />
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={modalRef}
        onCloseModal={() => {}}
      />
      <PageInfo title={globalVariables.dogHistory} onClick={() => navigate(-1)}>
        {!isAdminRole && isNoviceSkiped && (
          <div className="flex justify-center border rounded-md py-2 border-[#2F62A5] w-[150px]">
            <span className="text-base font-regular text-[#2F62A5]">
              Novice Skipped
            </span>
          </div>
        )}
        {isAdminRole && (
           <div className="flex gap-4">
            {!isNoviceSkiped ? (
              <Button
                width={"w-auto"}
                prefix={false}
                label={globalVariables.skipNovice}
                onClick={() => skipNoviceRef.current?.openModal()}
              />
            ) : (
              <div className="flex justify-center border rounded-md py-2 border-green bg-lightGreen w-[150px]">
                <span className="text-base font-regular text-green">
                  Novice Skipped
                </span>
              </div>
            )}
            {dogDetails.payment_status === "Unpaid" && (
              <Dropdown
                width="w-[150px]"
                placeholder="Unpaid"
                dropdownOptions={[globalVariables.markAsPaid]}
                customContent="justify-center"
                mainContent="w-100%"
                onChange={(option) => onChangeStatus(option)}
              />
            )}
  
            {(dogDetails.payment_status === "Paid"  || 
              dogDetails.payment_status === "Mark as Paid") &&
              (
              <div className="flex justify-center border rounded-md py-2 border-[#17B26A] bg-[#F6FEF9] w-[150px]">
                <span className="text-base font-regular text-[#17B26A]">
                  {globalVariables.paid}
                </span>
                <img src={successPayment} className="ml-1" alt="Success" />
              </div>
            )}
      </div>
      )}
    </PageInfo>
      <div>
        <div
          className={`flex flex-row justify-between lg:mr-8 md:mr-8 mr-6 ${
            isAdmin && "ml-6 lg:ml-0"
          } items-center`}
        >
          {/* {!(isAdmin && host) && (
            <div className="hidden lg:flex">
              <Button
                width={"w-32"}
                onClick={() => navigate("/admin/manage/dogs/editProfile")}
                label={globalVariables.edit}
              />
            </div>
          )} */}
          {/* {!(isAdmin && host) && (
            <div className="lg:hidden">
              <TextButton
                onClick={() => navigate("/admin/manage/dogs/editProfile")}
                label={globalVariables.edit}
              />
            </div>
          )} */}
        </div>
        <div className={`flex justify-between items-center ${isMobile ? "px-4" : ""}`}>
          <p className="text-2xl font-bold text-gray-700 mb-4">{globalVariables.myDogs}</p>
          {/* Show edit icon for admins/hosts OR for members viewing their own dogs */}
          {(isAdmin || (!isAdmin && !host && data?.getMyRegisteredDogs?.length > 0)) && (
            <div
              onClick={() => editDogModalRef.current?.openModal()}
              className="cursor-pointer"
            >
              <img src={pencilAlt} alt="" />
            </div>
          )}
        </div>
      
        {!isAdmin && (
          <div className={`${isMobile ? "px-4" : ""} ${isTablet && "px-6"}`}>
            <TabBar
              defaultTab={dogIndex}
              tabs={data?.getMyRegisteredDogs?.map((e) => e?.call_name)}
              onChangeTab={(index) => {
                setTabChanged(!tabChanged);
                getDogHistory(
                  data?.getMyRegisteredDogs?.[index]?.id,
                  data?.getMyRegisteredDogs?.[index]?.dog_id
                );
              }}
            />
          </div>
        )}
        <div className={isMobile ? "px-4" : ""}>
          {!isAdmin && !host ? (
            <AdminDogInfo
              isAdmin={true}
              dogInfo={dashboardData}
              tabChanged={tabChanged}
              setDashboardData={setDashboardData}
            />
          ) : (
            <AdminDogInfo
              dogInfo={dashboardData}
              setDashboardData={setDashboardData}
            />
          )}
        </div>
        <div className={`flex flex-col lg:flex-row gap-4 my-4 ${isMobile ? "px-4" : ""}`}>
          <div className="flex-1">
            <InfoCard
                title={globalVariables.scentIndicationTest}
                data={dogSIT}
                showLeft
                isAdmin={isAdmin}
                host = {host}
                type="SIT"
                onSelectSitValue={updateSITValue}
              />
          </div>
          <div className="flex flex-col  gap-4 flex-1">
            <SimpleCard
              title={globalVariables.noTitles}
              subTitle={dashboardData?.noOfTitles}
            />
            <SimpleCard
              title={globalVariables.noTrialsEntered}
              subTitle={dashboardData?.noofTrialEarned}
            />
            {/* <SimpleCard
              title={globalVariables.noQualifications}
              subTitle={dashboardData?.noOfQualification}
            /> */}
          </div>
        </div>
        {isAdmin && !host && (
          <div
            className={`my-6 flex flex-col p-6 bg-white rounded-md shadow-100 ${
              isMobile ? "ml-4 mr-4" : ""
            }`}
          >
            <div className="flex flex-row justify-between">
              <div className="w-[85%]">
                <div className="flex flex-row items-center">
                  <span className="text-xl font-semibold text-gray-900">
                    {`${globalVariables.note}:`}
                  </span>
                  <div className="mr-2" />
                  <img src={editBlack} alt="" />
                </div>
                <div className="mt-2">
                  <span className="text-sm font-medium text-gray-700">
                    {dashboardData?.dog?.notes
                      ? dashboardData?.dog?.notes
                      : "-"}
                  </span>
                </div>
              </div>
              {isAdmin && !host && (
                <button
                  onClick={() => addNoteModalRef.current?.openModal()}
                  className={`h-10 flex flex-row rounded-lg p-[10px] bg-white border-gray-300 border items-center mt-4 ${
                    dashboardData?.dog?.notes ? "w-[136px]" : "w-[106px]"
                  }`}
                >
                  <img src={addBlack} alt="" />
                  <span className="text-sm font-semibold text-gray-500">
                    {dashboardData?.dog?.notes
                      ? globalVariables.updateNote
                      : globalVariables.addNote}
                  </span>
                </button>
              )}
            </div>
          </div>
        )}
        <div className="flex flex-col lg:flex-row gap-4 mb-8">
          <div className="flex-1">
            {hasPremiumData ? (
              isMobile ? (
                <div className="mt-8">
                  <TableWithPagination
                    title={globalVariables.premiumPointsSummary}
                    tableBody={renderMobilePointSummaryTableBody()}
                    headerComponent={headerComponent()}
                    paddingVertical="py-4"
                    tableHeight="w-[368px]"
                    itemsPerPage={10}
                    totalPage={
                      allTrialIndividualDogHistory
                        ?.getAllTrialIndividualDogHistory?.totalPages
                    }
                    handlePageChange={setPremiumPointsPage}
                    loading={allTrialIndividualLoading}
                    current={premiumPointsPage}
                    persistPagination={true}
                    error={allTrialIndividualError}
                    extraClass={"mt-10"}
                  />
                </div>
              ) : (
                <div className={`${isTablet ? "mt-6" : ""}`}>
                  <TableWithPagination
                    title={globalVariables.premiumPointsSummary}
                    headData={pointSummaryHeadData}
                    tableBody={renderPointSummaryTableBody()}
                    headerComponent={headerComponent()}
                    paddingVertical="py-4"
                    tableHeight="h-[500px]"
                    zIndex="z-0"
                    itemsPerPage={10}
                    totalPage={
                      allTrialIndividualDogHistory
                        ?.getAllTrialIndividualDogHistory?.totalPages
                    }
                    handlePageChange={setPremiumPointsPage}
                    loading={allTrialIndividualLoading}
                    current={premiumPointsPage}
                    persistPagination={true}
                    error={allTrialIndividualError}
                  />
                </div>
              )
            ) : null}
          </div>
          <div className="flex flex-col flex-1 gap-4">
            <CertificateTable />
            <EditeQs
              isAdmin={isAdmin}
              title={globalVariables.summaryStandard}
              data={getAllSummaryStandardData?.getAllSummary}
              isCountUpdatedHandler={isCountUpdatedHandler}
              dogId={dogId}
            />
            <EditeQs
              isAdmin={isAdmin}
              title={globalVariables.summaryPro}
              data={getAllSummaryProData?.getAllSummary}
              isCountUpdatedHandler={isCountUpdatedHandler}
              dogId={dogId}
            />
          </div>
        </div>
        {(hasPremierData || premierResultsLoading) ? (
          isMobile ? (
            <div className="mt-8">
              <TableWithPagination
                title={globalVariables.premierResults}
                tableBody={renderMobilePremierTableBody()}
                itemsPerPage={10}
                totalPage={
                  premierResults?.getAllPremierAndNonPremierResult?.totalPages
                }
                handlePageChange={setPremierResultsPage}
                loading={premierResultsLoading}
                current={premierResultsPage}
                persistPagination={true}
                error={error}
              />
            </div>
          ) : (
            <div className={`mt-6 ${isTablet ? "mx-6" : "mr-8"}`}>
              <TableWithPagination
                title={globalVariables.premierResults}
                headData={
                  isAdmin ? premierHeadData : premierHeadData.slice(0, -1)
                }
                tableBody={renderPremierTableBody()}
                tableHeight={"h-[600px]"}
                itemsPerPage={10}
                totalPage={
                  premierResults?.getAllPremierAndNonPremierResult?.totalPages
                }
                handlePageChange={setPremierResultsPage}
                loading={premierResultsLoading}
                current={premierResultsPage}
                persistPagination={true}
                error={error}
              />
            </div>
          )
        ) : null}
        {/* {nonPremierResults?.getAllPremierAndNonPremierResult?.data.length >
          0 && (
          <>
            {isMobile ? (
              <div className="mt-8">
                <TableWithPagination
                  title={globalVariables.noviceAdvancedResults}
                  tableBody={renderMobileNoviceTableBody()}
                  itemsPerPage={10}
                  totalPage={
                    nonPremierResults?.getAllPremierAndNonPremierResult
                      ?.totalPages
                  }
                  handlePageChange={setNonPremierResultsPage}
                  loading={nonPremierResultsLoading}
                  current={premierResultsPage}
                  persistPagination={true}
                  error={nonPremierError}
                />
              </div>
            ) : (
              <div className={`mt-6 ${isTablet ? "mx-6" : "mr-8"}`}>
                {nonPremierResults?.getAllPremierAndNonPremierResult?.data
                  ?.length > 0 && (
                  <TableWithPagination
                    title={globalVariables.noviceAdvancedResults}
                    headData={
                      isAdmin ? noviceHeadData : noviceHeadData.slice(0, -1)
                    }
                    tableBody={renderNoviceTableBody()}
                    itemsPerPage={10}
                    totalPage={
                      nonPremierResults?.getAllPremierAndNonPremierResult
                        ?.totalPages
                    }
                    handlePageChange={setNonPremierResultsPage}
                    loading={nonPremierResultsLoading}
                    current={premierResultsPage}
                    persistPagination={true}
                    error={nonPremierError}
                  />
                )}
              </div>
            )}
          </>
        )} */}
        {(nonPremierResultsLoading || nonPremierResults?.getAllPremierAndNonPremierResult?.data) && (
          <>
            {isMobile ? (
              <div className="mt-8">
                <TableWithPagination
                  title={globalVariables.noviceAdvancedResults}
                  tableBody={renderMobileNoviceTableBody()}
                  itemsPerPage={10}
                  totalPage={
                    nonPremierResults?.getAllPremierAndNonPremierResult
                      ?.totalPages
                  }
                  handlePageChange={setPremierResultsPage}
                  loading={nonPremierResultsLoading}
                  current={premierResultsPage}
                  persistPagination={true}
                  error={nonPremierError}
                />
              </div>
            ) : (
              <div>
                  <TableWithPagination
                    title={globalVariables.noviceAdvancedResults}
                    headData={
                      isAdmin ? noviceHeadData : noviceHeadData.slice(0, -1)
                    }
                    tableBody={renderNoviceTableBody()}
                    itemsPerPage={10}
                    totalPage={
                      nonPremierResults?.getAllPremierAndNonPremierResult?.
                        totalPages
                    }
                    handlePageChange={setNonPremierResultsPage}
                    loading={nonPremierResultsLoading}
                    current={nonPremierResultsPage}
                    persistPagination={true}
                    error={nonPremierError}
                  />
              </div>
            )}
          </>
        )}
      </div>
      <ModalCard
        ref={titlesEarnedModalRef}
        title={globalVariables.titlesEarned}
        subTitle={moment(
          allTitlesEarned?.getAllTitlesEarned?.data[allTitlesEarnedIndex]?.date
        ).format("MM/DD/YYYY")}
        data={[
          {
            key: allTitlesEarned?.getAllTitlesEarned?.data[allTitlesEarnedIndex]
              ?.search,
            value:
              allTitlesEarned?.getAllTitlesEarned?.data[allTitlesEarnedIndex]
                ?.shortName,
          },
        ]}
        buttonLabel={globalVariables.downloadCertificate}
        isIconLeft={false}
        icon={downloadWhite}
      />
      <ModalCard
        ref={premiumPointsModalRef}
        title={globalVariables.premiumPointsSummary}
        subTitle={moment(
          allTrialIndividualDogHistory?.getAllTrialIndividualDogHistory?.data[
            premiumPointsPage
          ]?.date
        ).format("MM/DD/YYYY")}
        data={[
          {
            key: globalVariables.trialLocation,
            value: showDefaultValue(
              allTrialIndividualDogHistory?.getAllTrialIndividualDogHistory
                ?.data[premierResultsIndex]?.trialLocation
            ),
          },
          {
            key: globalVariables.pointsEarned,
            value: showDefaultValue(
              allTrialIndividualDogHistory?.getAllTrialIndividualDogHistory
                ?.data[premierResultsIndex]?.earnedPoints
            ),
          },
          {
            key: globalVariables.totalPoints,
            value: showDefaultValue(
              allTrialIndividualDogHistory?.getAllTrialIndividualDogHistory
                ?.data[premierResultsIndex]?.totalPoints
            ),
          },
        ]}
      />
      <ModalCard
        ref={premierModalRef}
        title={globalVariables.premierResults}
        subTitle={moment(
          premierResults?.getAllPremierAndNonPremierResult?.data[premierResults]
            ?.date
        ).format("MM/DD/YYYY")}
        data={[
          {
            key: globalVariables.trialLocation,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.trialLocation
            ),
          },
          {
            key: globalVariables.element,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.search
            ),
          },
          {
            key: globalVariables.handler,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.handler
            ),
          },
          {
            key: globalVariables.div,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.div
            ),
          },
          {
            key: globalVariables.faultReason,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.faults
            ),
          },
          {
            key: globalVariables.faultReason,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.faultReason
            ),
          },
          {
            key: globalVariables.time,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.time
            ),
          },
          {
            key: globalVariables.points,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.points
            ),
          },
          {
            key: globalVariables.place,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.place
            ),
          },
          {
            key: globalVariables.timeLimit,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.timeLimit
            ),
          },
          {
            key: globalVariables.hideSet,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.hidesSet
            ),
          },
          {
            key: globalVariables.judgeNotes,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.judgeNotes
            ),
          },
          {
            key: globalVariables.searchName,
            value: showDefaultValue(
              premierResults?.getAllPremierAndNonPremierResult?.data[
                premierResultsIndex
              ]?.searchName
            ),
          },
          // Todo:- Will use it later.
          // { key: globalVariables.hide1, value: "Hide 1" },
          // { key: globalVariables.hide1, value: "Hide 1" },
          // { key: globalVariables.hide1, value: "Hide 1" },
        ]}
      />

      <ModalCard
        ref={noviceModalRef}
        title={globalVariables.noviceAdvancedResults}
        subTitle={moment(
          nonPremierResults?.getAllPremierAndNonPremierResult?.data[
            nonPremierResultsIndex
          ]?.date
        ).format("MM/DD/YYYY")}
        data={[
          {
            key: globalVariables.trialLocation,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.trialLocation
            ),
          },
          {
            key: globalVariables.element,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.search
            ),
          },
          {
            key: globalVariables.handler,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.handler
            ),
          },
          {
            key: globalVariables.dog,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.dog
            ),
          },
          {
            key: globalVariables.breed,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.breed
            ),
          },
          {
            key: globalVariables.div,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.div
            ),
          },
          {
            key: globalVariables.qNQ,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.qNq
            ),
          },
          {
            key: globalVariables.nqReason,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.ngReason
            ),
          },
          {
            key: globalVariables.time,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.time
            ),
          },
          {
            key: globalVariables.hidesFound,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.hidesFound
            ),
          },
          {
            key: globalVariables.faultReason,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.faultReason
            ),
          },
          {
            key: globalVariables.points,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.points
            ),
          },
          {
            key: globalVariables.place,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.place
            ),
          },
          {
            key: globalVariables.timeLimit,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.timeLimit
            ),
          },
          {
            key: globalVariables.hideSet,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.hidesSet
            ),
          },
          {
            key: globalVariables.judgeNotes,
            value: showDefaultValue(
              nonPremierResults?.getAllPremierAndNonPremierResult?.data[
                nonPremierResultsIndex
              ]?.judgeNotes
            ),
          },
        ]}
      />
      <SkipNoviceModal 
        modalRef={skipNoviceRef}
        onCloseSkipNoviceModal={() => skipNoviceRef.current?.closeModal()}
        skipNoviceHandler={skipNoviceHandler}
      />
      <EditDogCard 
        ref={editDogModalRef}
        dogInfo={dashboardData}
        setIsDataUpdated={setIsDataUpdated}
      />
      <AddNoteModal
        ref={addNoteModalRef}
        title={globalVariables.addNote}
        dogId={dogIdData}
        note={dashboardData?.dog?.notes}
        onSubmit={() => {
          getDashboardData(dogIdData);
        }}
      />
      <EditNAEResult
        ref={EditNAEModalRef}
        initialData={selectNAEData}
        onUpdateSuccessful={() => {
          // Refresh the specific results list
          if (isEditingPremierResults) {
            getData({
              variables: {
                pageNumber: premierResultsPage,
                pageSize: 10,
                dogId: newDogId,
                search: "Premier",
              },
            });
          } else {
            getnonPremierResultsData({
              variables: {
                pageNumber: nonPremierResultsPage,
                pageSize: 10,
                dogId: newDogId,
                search: "Nonpremier",
              },
            });
          }

          // Refresh all related data to update Q/NQ counts and summaries
          getDashboardData(dogIdData);

          // Refetch summary data (Q counts)
          if (getAllSummaryProRefetch) {
            getAllSummaryProRefetch();
          }
          if (getAllSummaryStandardRefetch) {
            getAllSummaryStandardRefetch();
          }

          // Refetch titles if needed
          if (allTitlesRefetch) {
            allTitlesRefetch();
          }
        }}
      />
      <Certificate setLoading={setCertLoading} ref={certificateRef} />
    </div>
  ) : (
    <div
      className={`App lg:rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10`}
    >
    <PageInfo title={globalVariables.dogHistory} onClick={() => navigate(-1)} />
    <div className="h-[70vh] flex justify-center items-center text-center mt-4">
      {loading ? (
        <Loader />
      ) : (
        <span className="text-base font-semibold">
          {globalVariables.noDataAvailable}
        </span>
      )}
    </div>
  </div>
  );
};
